import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Lock, ArrowUpRight } from "lucide-react";

let _cache = null;
let _promise = null;

export const fetchPlan = (force = false) => {
  if (_cache && !force) return Promise.resolve(_cache);
  if (!_promise || force) {
    _promise = api.get("/subscriptions/features")
      .then(r => { _cache = r.data; return _cache; })
      .catch(() => ({ gated: false, features: {} }));
  }
  return _promise;
};

export const usePlan = () => {
  const [plan, setPlan] = useState(_cache);
  useEffect(() => { fetchPlan().then(setPlan); }, []);
  return plan;
};

export const UpgradeGate = ({ feature, title, children }) => {
  const plan = usePlan();
  if (!plan) return null;
  if (!plan.gated || plan.features?.[feature]) return children;
  const needed = plan.feature_plans?.[feature] || "a higher";
  return (
    <div className="p-6 lg:p-8 flex items-center justify-center min-h-[70vh]" data-testid="upgrade-gate">
      <div className="max-w-md w-full text-center rounded-2xl border border-white/10 bg-white/[0.02] p-10">
        <div className="w-14 h-14 mx-auto rounded-2xl bg-gradient-to-br from-cyan-400/20 to-blue-500/10 border border-cyan-400/30 flex items-center justify-center mb-5">
          <Lock className="w-6 h-6 text-cyan-300" />
        </div>
        <h2 className="font-display text-2xl font-bold text-white">{title || "This feature"} is a {needed} feature</h2>
        <p className="text-sm text-slate-400 mt-3 leading-relaxed">
          You're on the <span className="text-white">{plan.plan_name}</span> plan{plan.no_subscription ? " preview" : ""}. Upgrade to unlock {title ? title.toLowerCase() : "this feature"} and everything else in the {needed} tier.
        </p>
        <Link to="/billing" data-testid="upgrade-gate-billing-btn"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-cyan-400 to-blue-500 text-slate-900 font-semibold text-sm px-6 py-2.5 hover:opacity-90 transition-opacity">
          View plans & upgrade <ArrowUpRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};
